import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Checkbox,
    InputLabel
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from "react-i18next";
import InputContainer from '../../citizen/TCPForms/layout/inputContainer';
import ButtonWrapper from '../../citizen/TCPForms/components/Button';
import { OBPSService } from '../../../../../../libraries/src/services/elements/OBPS';
import { convertDateToEpoch } from '@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date';


const ScheduleInspection = () => {
    const { control, handleSubmit } = useForm();
    const [selectedRows, setSelectedRows] = useState([]);
    const tenantId = 'hp'
    const initialStates = {}
    const { t } = useTranslation();
    const [pageOffset, setPageOffset] = useState(initialStates?.pageOffset || 0);
    const [pageSize, setPageSize] = useState(initialStates?.pageSize || 10);
    const [sortParams, setSortParams] = useState(initialStates?.sortParams || [{ id: "applicationDate", desc: false }]);
    const [setSearchFieldsBackToOriginalState, setSetSearchFieldsBackToOriginalState] = useState(false)
    const [searchParams, setSearchParams] = useState(() => {
        return initialStates?.searchParams || {};
    });

    let isMobile = window.Digit.Utils.browser.isMobile();
    let paginationParams = isMobile
    ? { limit: 100, offset: 0, sortBy: sortParams?.[0]?.id, sortOrder: sortParams?.[0]?.desc ? "DESC" : "ASC" }
    : { limit: pageSize, offset: pageOffset, sortBy: sortParams?.[0]?.id, sortOrder: sortParams?.[0]?.desc ? "DESC" : "ASC" };

    const { isFetching, isLoading: hookLoading, searchResponseKey, data, searchFields, ...rest } = Digit.Hooks.obps.useAllformInbox({
    tenantId,
    filters: { ...searchParams, ...paginationParams, sortParams },
    config: {}
  });
  
  useEffect(() => {
    setPageOffset(0);
  }, [searchParams]);

  
    const handleRowClick = (row) => {
        const isSelected = selectedRows.some((selectedRow) => selectedRow.applicationNo === row.applicationNo);

        if (isSelected) {
            setSelectedRows((prev) => prev.filter((selectedRow) => selectedRow.applicationNo !== row.applicationNo));
        } else {
            setSelectedRows((prev) => [...prev, row]);
        }
    };

    const handleSelectAllClick = () => {
        if (selectedRows.length === data?.table?.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows([...data?.table]);
        }
    };

    const onSubmit = async (data) => {
        let InspectionDetail 
        selectedRows?.map((detail) => {
            detail.inspectionTime =  `${data?.inspectionTime?.$H}:${data?.inspectionTime?.$m}:${data?.inspectionTime?.$s}`
            detail.inspectionDate = convertDateToEpoch(data?.inspectionDate)
            detail.inspectionRemark = data?.remarks
            detail.applicationNo = detail?.applicationNo
            detail.tenantId = tenantId
        })
        InspectionDetail = selectedRows
        const response = await OBPSService.scheduleInspection({InspectionDetail})
        if(response){
            alert('Inspection details has been sent to applicant')
        }
    };

    return (
        <section className="container1">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer" style={{marginLeft: '20px'}}>
                        <h2 className="formHeading">
                            Schedule Inspection
                        </h2>
                    </div>
                    <div className="formInputContainer" style={{width: '90%', marginLeft: '30px'}}>
                        <div className="columnWrapper" style={{width: '50%'}}>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Checkbox
                                                    indeterminate={
                                                        selectedRows.length > 0 && selectedRows.length <= data?.table?.length
                                                    }
                                                    checked={selectedRows.length === data?.table?.length}
                                                    onChange={handleSelectAllClick}
                                                />
                                            </TableCell>
                                            <TableCell>Name & Form-No</TableCell>
                                            <TableCell>Application No</TableCell>
                                            <TableCell>Mobile No</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.table?.map((row) => (
                                            <TableRow key={row.applicationNo} onClick={() => handleRowClick(row)}>
                                                <TableCell>
                                                    <Checkbox checked={selectedRows.some((selectedRow) => selectedRow?.applicationNo === row.applicationNo)} />
                                                </TableCell>
                                                <TableCell>
                                                   <p>{row?.owner}</p> 
                                                   <p>{row?.formNo}</p> 
                                                </TableCell>
                                                <TableCell>{row?.applicationNo}</TableCell>
                                                <TableCell>{row?.mobileNumber}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className="columnWrapper">
                                <InputContainer
                                    label="Inspection Date"
                                    control={control}
                                    placeholder="Select Date"
                                    name="inspectionDate"
                                    type="datePicker"
                                />

                                <InputContainer
                                    label="Inspection Time"
                                    control={control}
                                    placeholder="Select Time"
                                    name="inspectionTime"
                                    type="timePicker"
                                />

                                <InputContainer
                                    label="Remarks"
                                    control={control}
                                    placeholder="Remarks...."
                                    name="remarks"
                                    type="textInput"
                                    mandatory
                                    multiLine
                                    labelWidth="70%"
                                />
                        </div>
                    </div>
                    <div className="footerContainer" style={{marginTop: '50px'}}>
                        <div className="buttonWrapper">
                            <ButtonWrapper
                                variant="contained"
                                color="success"
                                size="medium"
                                label="Submit"
                                type="submit"
                                onClick={handleSubmit}
                            />
                            <ButtonWrapper
                                variant="contained"
                                color="error"
                                size="medium"
                                label="Reset"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </section>
    );
};


export default ScheduleInspection;
